var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReturn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.5 6h.5V3H3v3zM20 21H4V7h16zM2 2.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H21v14.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5V7h-.5a.5.5 0 0 1-.5-.5zm8.5 13.178a.5.5 0 0 1-.354-.146l-2.545-2.545a.5.5 0 0 1 0-.707l2.545-2.546a.5.5 0 0 1 .707.707l-1.557 1.56H14c1.378 0 2.5 1.12 2.5 2.5 0 1.378-1.123 2.5-2.5 2.5a.5.5 0 1 1 0-1 1.501 1.501 0 0 0 0-3H9.028l1.826 1.824a.5.5 0 0 1-.353.853"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReturn);
export default ForwardRef;